<template>
  <div class="common-map-select">
    <div class="search-wrap" v-if='config.mapak_type == 2'><i class="iconfont" @click="searchAddress">&#xe6cb;</i><input type="text" v-model="keyword"><div @click="searchAddress" class="btn">搜索</div></div>
	<div class="search-wrap" v-else><i class="iconfont">&#xe6cb;</i><input type="text" v-model="keyword" id="input"></div>
    <div id='container'></div>
    <!--<div id="common_map_select" :style="{height:.45*wrapperHeight+'px'}"></div>-->
    <div class="result-list" >
      <div :class="{'current':style}" v-if="member_point && style && ifShowCurrent">
        <span class="notice">当前地址<span class="reset" @click="getPosition"><i class="iconfont">&#xe6d3;</i>重新定位</span></span>
        <div>
          <div class="result-item" style="border-bottom:0" @click="setPosition(member_point.lat,member_point.lng,member_point.address)">{{member_point.address}}</div>
        </div>
      </div>
      <div :class="{'nearby':style}">
        <span class="notice">附近地址</span>
        <div v-for="(item,index) in address_list" :key="index">
          <div class="result-item" v-if="item.location" @click="setPosition(item.location.lat,item.location.lng,item.name)">{{item.name}}</div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { getAddressByKeyword, getAddressByPoint, getPointNearby, getPosition } from '../util/bmap'
import { mapState, mapMutations } from 'vuex'
import { Toast, Indicator } from 'mint-ui'
 import { loadScript } from '../util/common'
export default {
  name: 'MapSelect',
  data () {
    return {
      keyword: '',
      address_list: [],
      // wrapperHeight: 0,
      bmap: false,
      myMarker: false,
      cityCode: 0,
      style: false
    }
  },
  props: {
    longitude: {},
    latitude: {},
    ifShowCurrent:{
    type:Boolean,
    default:false
    },
  },
  watch: {
    longitude: function (newLongitude, oldLongitude) {
      if (newLongitude) {
        this.creatMap()
      }
    },
	keyword(newVal) {
		if(this.config.mapak_type == 1){
			this.GDmap();  
		}
	}
  },
  computed: {
    ...mapState({
      member_point: state => state.member.point,
	  config: state => state.config.config
    })
  },
  mounted () {
	  
    // this.wrapperHeight = document.documentElement.clientHeight - 80
    // let _this = this
    // loadScript(function () {
    //   _this.wrapperHeight = document.documentElement.clientHeight - 80
    //   _this.bmap = new BMap.Map('common_map_select')
    //
    //   var zoomCtrl = new BMap.ZoomControl({ anchor: BMAP_ANCHOR_BOTTOM_RIGHT, offset: new BMap.Size(20, 20) })
    //   _this.bmap.addControl(zoomCtrl)
    //   _this.creatMap()
    // })
  },
  created () {
	  if(this.config.mapak_type == 2){
		if (this.longitude) {
		  this.creatMap()
		}
	  }else{
		  window._AMapSecurityConfig = {
		      securityJsCode:this.config.gaode_jscode,
		  }
		  loadScript('Amap', '//webapi.amap.com/maps?v=2.0&key='+ this.config.gaode_ak, function () {})
	  }
  },
  methods: {
    ...mapMutations({
      memberPoint: 'memberPoint'
    }),
	GDmap(){
		 //高德地图
		 let _this = this 
		 //搜索定位
		 AMap.plugin('AMap.AutoComplete', function(){
			 let autoOptions = {
				 city: '全国',
				 }
			let auto = new AMap.AutoComplete(autoOptions);
			auto.search(_this.keyword, function(status, result) {
				if(result){
				 _this.address_list = result.tips 
				 }
				})
		});
	},
    getPosition () {
      let _this = this
      Indicator.open()
      getPosition(function (res) {
        Indicator.close()
        if (res.code === 10000) {
          _this.getAddressByPoint(res.result.lat, res.result.lng)
        } else {
          Toast(res.message)
        }
      }, true)
    },
    getAddressByPoint (lat, lng) {
      getAddressByPoint(lat + ',' + lng).then(res => {
        this.cityCode = res.result.cityCode
        this.memberPoint({ point: { lng: lng, lat: lat, address: res.result.sematic_description, cityCode: res.result.cityCode } })
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    creatMap () {
      this.getAddressByPoint(this.latitude, this.longitude)
      // 附近地址
      getPointNearby(this.latitude + ',' + this.longitude).then(res => {
        this.address_list = res.results
        this.style = true
      }).catch(function (error) {
        Toast(error.message)
      })
      // let point = new BMap.Point(this.longitude, this.latitude)
      // 创建点坐标
      // this.bmap.centerAndZoom(point, 16)
      // this.myMarker = new BMap.Marker(point)
      // this.bmap.addOverlay(this.myMarker)
    },
    searchAddress () {
      getAddressByKeyword(this.keyword, this.cityCode).then(res => {
        this.address_list = res.result
        this.style = false
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    setPosition (lat, lng, name) {
      this.$emit('setPosition', lat, lng, name, this.cityCode)
    }
  }
}
</script>
<style  lang="scss" scoped>
  .common-map-select{background: #fff;position: absolute;width:100%;height:100%;
    .search-wrap{height: 2rem;line-height: 2rem;position: relative;position: absolute;left:.5rem;top:$pageSpace;right:$pageSpace;background: #F5F5F5;display: flex;border-radius:.4rem;overflow: hidden;
      input{width: 100%;line-height: 2rem;font-size:$h2;display: block;background: none;border: 0;flex:1}
      i{font-size:$h1;line-height: 2rem;display: block;width:2rem;text-align: center}
      .btn{background: $primaryColor;color:#fff;font-size:$subFontSize;padding:0 .5rem;}
    }
    .result-list{overflow-y:auto;position: absolute;top:3rem;bottom:0rem;width:100%;
      .notice{display: none;padding:1rem $pageSpace 0 $pageSpace;font-size:$subFontSize;color:#aeaeae;line-height: 1.5}
      .reset{float: right;color:$primaryColor}
      .current .notice,.nearby .notice{display: block}
      .current{box-shadow: 0px 4px 4px #f7f7f7;}
      .result-item{padding:.7rem 0;font-size:$h2;color:#333;border-bottom: 1px dashed #eee;margin:0 $pageSpace;}
    }
  }
</style>
